import React from 'react';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

const title = "2.1 - Le Songe d'une nuit d'été";
const subtitle = "Type : Thêatre";
const desc = "Comédie/Fantasy | Shakespare / Repris par D'Hoop JM";



function Songe() {

  return (
    
    <div>
        <div className="bg-[url(https://cdn.discordapp.com/attachments/1023181262460035113/1118146687018483812/un790xOv_4x.png)] bg-cover">
            <div className='bg-black bg-opacity-75'>
                <div className="relative overflow-hidden">
                    <Header title={title} subtitle={subtitle} desc={desc} />
                </div>
          </div>
        </div>

      <div className='overflow-hidden py-10 bg-light'>
        <div className="max-w-6xl px-2 mx-auto sm:px-6 py-2 pb-4 bg-darkbrown rounded-xl">
            <div className="leading-loose text-lg my-6 px-6 text-light">
                
            <div id='identification' className='pb-4'>
                <h1 className="text-secondary text-3xl font-bold">1 | Identification</h1>
                <p className='text-base mt-3 ml-10'>
                    <ul className='list-disc'>
                        <li>Auteur : William Shakespeare</li>
                        <li>Metteur en scène : Jean-Michel D’Hoop</li>
                        <li>Titre : Le Songe d’une nuit d’été</li>
                        <li>Date de réalisation : 8 octobre 1600 | 6 octobre 2022 </li>
                        <li>Compagnie théâtrale : Point Zéro</li>
                        <li>Lieu de représentation : Thèatre le Manège (Mars) </li>
                        <li>Technique/Support : Thêatre</li>
                        <li>Genre : Comédie</li>
                    </ul>
                
                </p>
            </div>

            <div id='description' className='pb-4'>
                <h1 className="text-secondary text-3xl font-bold">2 | Description</h1>
                <p className='text-base mt-3 ml-10'>

                Le duc Thésée était sur le point d'épouser Hippolyta lorsqu'il reçut la visite de Égée. Ce dernier s'est plaint que sa fille Hermia était tombée amoureuse de Lysandre et a refusé de se marier avec Demetrius, l’homme qu’il a préparé pour sa fille. La jeune fille s'enfuit alors avec son bien-aimé dans les bois pour éviter le mariage avec Demetrius. Ils rejoignirent bientôt Helena, amoureuse de Démétrius, et Titania, la reine d'Oberon et ses fées, qui se disputèrent. Mais ça, c’est l'œuvre de base de Shakespeare. La pièce de théâtre que nous avions vu, different sur certains points car elle a été adaptée avec des codes du XXIème siècle.
                <br /><br />
                <div class="italic opacity-75">“Cette adaptation du Songe est avant tout une comédie, un genre de vaudeville féérique. Une épopée amoureuse et poétique dans les forêts shakespeariennes, là où se révèlent les passions, se dévoilent les secrets, se poursuivent les amant·es dans un chassé-croisé avec elfes et fées d’un genre tout à fait spécial. Une quinzaine de marionnettes géantes autour de 8 comédien·nes nous font pénétrer dans le monde de la nuit où fées et farfadets prennent l’allure de flamboyantes drag-queens et où tous les fantasmes sont permis.
                Peur, excitation, course folle aux désirs sont au rendez-vous !” - <a href="https://surmars.be/evenement/le-songe-dune-nuit-dete/2022-10-06/" target='_blank' rel='noopener noreferer'  className='text-primary hover:underline'>surmars.be</a></div>

                </p>
            </div>

            <div id='interprétation' className='pb-4'>
                <h1 className="text-secondary text-3xl font-bold">3 | Interprétation</h1>
                <p className='text-base mt-3 ml-10'>
                Cette pièce de théâtre a 2 mondes : le monde “réel”, à Athènes, avec des règles strictes, patriarcales et autoritaires et le monde des fées, ou tout le monde est libre, il n’y a ni règles. Ils n’ont pas de concept de fidélité et ils sont libres de dire quel genre leur va, car même Titania est transgenre.

                <br /> <br />
                Je vois le rapport entre les deux comme l’ancien monde du XXe siècle et le monde des fées représente notre monde actuel, ou du moins vers ou le monde se dirige.


                </p>
            </div>

            
            <div id='jugementdegout' className='pb-4'>
                <h1 className="text-secondary text-3xl font-bold">4 | Jugement de goût</h1>
                <p className='text-base mt-3 ml-10'>
                J’ai un avis assez mitigé sur cette pièce. Je n’ai pas vraiment apprécié le moment mais j’ai quand même des choses positives que j’aimerai y apporter.
<br /><br />
Tout d’abord, j’ai été fort impressionné par la performance des artistes. Leur maniement de leur marionnette était vraiment bien, et on s’est senti immergé dans la scène. Les éclairages et le son également, était parfait.
<br /><br />
Pour ce qui est des points négatifs sur cette pièce, je l’ai trouvée très longue. A la fin, j’étais limite pressé que ça se termine car la pièce m’ennuyait vraiment. Les personnages étaient peu attachants et l’intrigue était indigeste.
<br /><br />
Comme Shakespeare est du style baroque, c’est assez logique mais ce genre d’intrigue qui vont dans tous les sens me déplaît et est un peu ennuyeux à mon humble opinion. L’humour dans cette pièce est à la fois un bon point et un mauvais. Car les blagues absurdes des personnages, comme la troupe qui a fait le théâtre pour le mariage de Thésée et Hippolyte, m'ont paru drôle mais les blagues répétitives des autres personnages ne m'ont même pas fait sourire.

       
                </p>
            </div>
            <div id='focus' className='pb-4'>
                <h1 className="text-secondary text-3xl font-bold">5 | Focus</h1>
                <p className='text-base mt-3 ml-10'>
                L'élément qui se démarque dans cette adaptation est le langage utilisé, plus moderne et en phase avec notre époque. Cela facilite la compréhension par rapport à la pièce originale, vieille de plusieurs siècles, tout en rendant les références et les blagues plus accessibles. 
                <br /><br />
                Cette modernisation linguistique offre une meilleure identification avec les personnages et une expérience plus plaisante. De plus, elle ancre les thèmes et les enjeux dans notre réalité actuelle, suscitant une réflexion pertinente et créant une connexion plus étroite avec le public contemporain. Cette adaptation réussit à allier fraîcheur, accessibilité et pertinence en utilisant un langage plus moderne.



                </p>
            </div>

            <div id='bibliographie' className='pb-4'>
                <h1 className="text-secondary text-3xl font-bold text-center">~ Bibliographie ~</h1>
                <p className='text-sm mt-3 ml-10'>
                    <ul>
                        <li>« William Shakespeare ». Wikipedia, juin 2023, <a className='text-primary hover:underline' target='_blank' rel="noopener noreferrer" href="https://fr.wikipedia.org/wiki/William_Shakespeare">fr.wikipedia.org/wiki/William_Shakespeare</a>.</li>
                        <li>Charue, Marie, « Songe d’une nuit d’été sous acide . Karoo» . Karoo, 3 mai 2022, <a className='text-primary hover:underline' target='_blank' rel="noopener noreferrer" href="https://karoo.me/scene/songe-dune-nuit-dete-sous-acide">karoo.me/scene/songe-dune-nuit-dete-sous-acide</a>.</li>
                        <li>« Le Songe d’une nuit d’été ». Mars - Mons arts de la scène, 5 septembre 2022, <a className='text-primary hover:underline' target='_blank' rel="noopener noreferrer" href="https://surmars.be/evenement/le-songe-dune-nuit-dete/2022-10-06">surmars.be/evenement/le-songe-dune-nuit-dete/2022-10-06</a>.</li>


                    </ul>
                </p>
            </div>

            </div>

        </div>
      </div>

      <Footer />

    </div>
  );
}

export default Songe;
